import { useCallback, useEffect, useState } from "react";
import { listInviteCards } from "./inviteCardsApi.js";

/**
 * Fetches the owning Agent's Invite Card list once (page=1, pageSize=100 -
 * the bounded single-page fetch the P089R contract suggests). Status/search
 * filtering happens client-side over this one fetch (see
 * AgentInviteCardsPage) rather than a new network call per filter chip -
 * matching how SuperAgentsOverviewPage filters its already-loaded tree.
 *
 * Never fetches when agentId is falsy - this is what lets the page render
 * the "no owning Agent scope" reserved state without ever calling the
 * invite card API.
 */
export function useInviteCardsList(agentId) {
  const [state, setState] = useState({ status: "idle", data: null, error: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!agentId) {
      setState({ status: "idle", data: null, error: null });
      return undefined;
    }

    let cancelled = false;
    setState((previous) => ({ status: "loading", data: previous.data, error: null }));

    listInviteCards(agentId, { page: 1, pageSize: 100 })
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({ status: "error", data: null, error });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [agentId, reloadToken]);

  const refetch = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, refetch };
}
